import {createAction} from "@reduxjs/toolkit";

// CubicleLog type
export const CREATE_CUBICLE_LOG = '[CUBICLE_LOG] Creating cubicle log';
export const UPDATE_CUBICLE_LOG = '[CUBICLE_LOG] Updating cubicle log';
export const GET_CUBICLE_LOG = '[CUBICLE_LOG] Getting cubicle log';
export const GET_CUBICLE_LOG_SUCCESS = '[CUBICLE_LOG] Getting cubicle log success';
export const SET_OCCUPIED_CUBICLE_LOG = '[CUBICLE_LOG] Setting occupied cubicle log';
export const SET_UNOCCUPIED_CUBICLE_LOG = '[CUBICLE_LOG] Setting unoccupied cubicle log';

export const GET_ON_GOING_QUEUE = '[CUBICLE_LOG] Getting on going queue';
export const GET_ON_GOING_QUEUE_SUCCESS = '[CUBICLE_LOG] Getting on going queue success';

export const GET_BASIC_FACULTY_REPORT = '[CUBICLE_LOG] Getting basic faculty report';
export const GET_BASIC_FACULTY_REPORT_SUCCESS = '[CUBICLE_LOG] Getting basic faculty report success!';

export const GET_BASIC_STUDENT_REPORT = '[CUBICLE_LOG] Getting basic student report';
export const GET_BASIC_STUDENT_REPORT_SUCCESS = '[CUBICLE_LOG] Getting basic student report success!';

// CubicleLog actions
export const createCubicleLog = createAction(CREATE_CUBICLE_LOG);
export const updateCubicleLog = createAction(UPDATE_CUBICLE_LOG);
export const getCubicleLog = createAction(GET_CUBICLE_LOG);
export const getCubicleLogSuccess = createAction(GET_CUBICLE_LOG_SUCCESS);
export const setOccupiedCubicleLog = createAction(SET_OCCUPIED_CUBICLE_LOG);
export const setUnoccupiedCubicleLog = createAction(SET_UNOCCUPIED_CUBICLE_LOG);

export const getOnGoingQueue = createAction(GET_ON_GOING_QUEUE);
export const getOnGoingQueueSuccess = createAction(GET_ON_GOING_QUEUE_SUCCESS);

export const getBasicFacultyReport = createAction(GET_BASIC_FACULTY_REPORT);
export const getBasicFacultyReportSuccess = createAction(GET_BASIC_FACULTY_REPORT_SUCCESS);

export const getBasicStudentReport = createAction(GET_BASIC_STUDENT_REPORT);
export const getBasicStudentReportSuccess = createAction(GET_BASIC_STUDENT_REPORT_SUCCESS);
